<template>
  <span class="icon">
    <img :src="src" alt="">
  </span>
</template>

<script>
export default {
  name: 'icon',
  props: {
    glyph: {
      required: true,
      type: String
    },
    color: {
      required: true,
      type: String
    }
  },
  computed: {
    src: function () {
      let filename = this.glyph
      filename += (this.color) ? `-${this.color}.svg` : '.svg'

      return require(`../assets/images/icons/${filename}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon,
.icon img {
  width: 100%;
  height: 100%;
}
// .icon {
//   color: #000;
//   background: rgba(255, 255, 255, 0.58);
//   border-radius: 50%;
//   width: 34px;
//   height: 34px;
// }

</style>




// WEBPACK FOOTER //
// Icon.vue?df93baee